export default __webpack_public_path__ + "static/media/v2_footer_bg.a640b45d.png";